import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { StakingPoolItemModel } from "src/models/StakingPool";
import { CustomButton } from "./CustomButton";

type StakingPoolItemProps = {
  poolItem: StakingPoolItemModel;
  onClickDelegate: Function;
};

export const StakingPoolItem = (props: StakingPoolItemProps) => {
  const { poolItem } = props;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      borderRadius="8px"
      width="200px"
      p="10px"
      sx={{
        backgroundColor: "#1D232A",
      }}
    >
      <Box
        borderRadius="6px"
        alignSelf="stretch"
        display="flex"
        justifyContent="center"
        pt="17px"
        pb="20px"
        sx={{
          backgroundColor: "#191C24",
        }}
      >
        <img src={poolItem.icon} width="55px" height="55px" alt="icon" />
      </Box>

      <Typography fontSize="20px" color="white" variant="bold" mt="17px">
        {poolItem.displayApy}%
      </Typography>

      <Typography fontSize="12px" color="secondary" mt="10px">
        {poolItem.nodeName} ({poolItem.symbol})
      </Typography>

      <Box mt="30px" mb="9px">
        <CustomButton
          disabled={!poolItem.opened}
          fontSize="18px"
          padding="10px 36px"
          color="darkButtonBg"
          onClick={() => {
            props.onClickDelegate();
          }}
        >
          {poolItem.opened ? "Delegate" : "//"}
          {/* Coming */}
        </CustomButton>
      </Box>
    </Box>
  );
};
